export default class rmBlockSwitch {
    constructor() {
        return {
            scope: {},
            transclude: true,
            template: require('../../../../views/maileditor/rm-block-switch.html'),
            restrict: 'E',
            controller: RmBlockSwitchCtrl,
            controllerAs: 'ctrl'
        }
    }
};

class RmBlockSwitchCtrl {
    constructor($scope, $element, $attrs, $compile, $filter, $timeout, EditorEventHandler, Tag, Segment) {
        this._scope = $scope;
        this._element = $element;
        this._attrs = $attrs;
        this._compile = $compile;
        this._timeout = $timeout;
        this._translator = $filter('translate');
        this.editorEventHandler = EditorEventHandler;
        this.tagRepo = Tag;
        this.segmentRepo = Segment;

        this.selectedTagsMap = new Map();
        this.tags = null;
        this.tagsSearchQuery = '';
        this.currentTagsPage = 1;
        this.tagsPerPage = 20;
        this.useTagsPagination = true;
        this.tagsMetaData = null; // { count, current_page, per_page, total, total_pages }
        this.resetTagsSelectPagination = false;

        this.selectedSegmentsMap = new Map();
        this.segments = null;
        this.segmentsSearchQuery = '';
        this.currentSegmentsPage = 1;
        this.segmentsPerPage = 20;
        this.useSegmentsPagination = true;
        this.segmentsMetaData = null; // { count, current_page, per_page, total, total_pages }
        this.resetSegmentsSelectPagination = false;

        this.customizations = this.editorEventHandler.customizations;
        this.formattedFields = [];
        this.headerCaseInfo = '';

        this.setDefaultFields();
        this.setCustomizedFields();

        // Wait for ng-transclude rendering
        this._timeout(() => {
            this.getCasesFromHtml();

            this.cases.hide();
            this.setCurrentCase();
        });
    }

    $onInit() {
        this.fetchTags().then((tags) => {
            this.tags = tags.data;
            this.tagsMetaData = tags.meta.pagination;
            this.updateSelectedEntitiesMap();
        });

        this.fetchSegments().then((segments) => {
            this.segments = segments.data;
            this.segmentsMetaData = segments.meta.pagination;
            this.updateSelectedEntitiesMap();
        });
    }

    fetchTags() {
        return this.tagRepo.fetchAllNew(this.currentTagsPage, this.tagsPerPage, this.tagsSearchQuery, this.useTagsPagination);
    }

    fetchSegments() {
        return this.segmentRepo.fetchAllNew(this.currentSegmentsPage, this.segmentsPerPage, this.segmentsSearchQuery, this.useSegmentsPagination);
    }

    setCurrentCase() {
        let firstCase = this.cases.first();

        this.currentCase = {
            'index': 0,
            'element': firstCase,
            'field': this.parceSwitchValue(),
            'field_value': firstCase.data('value'),
            'isDefault': this.isDefault(firstCase)
        };
        this.currentCase.element.show();
    }

    isDefault(switchCase) {
        return switchCase.prop("tagName").toLowerCase() === 'rm-block-switch-default';
    }

    isCustomizationSwitch() {
        return !(this.currentCase.field === 'tags' || this.currentCase.field === 'filters');
    }

    parceSwitchValue() {
        let value = $(this._element).data('value');
        let regexCustom = /\[CustomField:(.*?)\.(.*?)\]/;
        let regexBase = /\@{(.*?)}/;
        if (regexCustom.test(value)) {
            let maches = value.match(regexCustom);
            angular.forEach(this.formattedFields, (field) => {
                if (field.groupName === maches[1] && field.name === maches[2]) {
                    value = field.id;
                }
            });
        } else if (regexBase.test(value)) {
            value = value.replace(regexBase, '$1');
        }

        return value;
    }

    updateSwitchHtml(switchValue) {
        let value;
        if (!switchValue.groupName) {
            value = '@{' + switchValue.id + '}';
        } else {
            value = '[CustomField:' + switchValue.groupName + '.' + switchValue.name + ']'
        }
        $(this._element).attr('data-value', value);
    }

    updateCaseHtml(caseValue) {
        this.currentCase.field_value = caseValue;
        this.currentCase.element.attr('data-value', caseValue);
        this.getCasesFromHtml();
        this.updateSelectedEntitiesMap();
    }

    searchTags(searchQuery) {
        this.resetTagsPagination();
        this.tagsSearchQuery = searchQuery;

        this.fetchTags().then((tags) => {
            this.tags = tags.data;
            this.tagsMetaData = tags.meta.pagination;
        });
    }

    loadMoreTags(index) {
        const allTagsCount = this.tagsMetaData.total;

        if (allTagsCount <= this.tagsPerPage) {
            return;
        }

        this.currentTagsPage = this.currentTagsPage + 1;

        this.fetchTags().then((tags) => {
            this.tags = [ ...this.tags, ...tags.data ];
            this.tagsMetaData = tags.meta.pagination;
        });
    }

    resetTagsPagination() {
        this.resetTagsSelectPagination = true;
        this.currentTagsPage = 1;
    }

    searchSegments(searchQuery) {
        this.resetSegmentsPagination();
        this.segmentsSearchQuery = searchQuery;

        this.fetchSegments().then((segments) => {
            this.segments = segments.data;
            this.segmentsMetaData = segments.meta.pagination;
        });
    }

    loadMoreSegments(index) {
        const allSegmentsCount = this.segmentsMetaData.total;

        if (allSegmentsCount <= this.segmentsPerPage) {
            return;
        }

        this.currentSegmentsPage = this.currentSegmentsPage + 1;

        this.fetchSegments().then((segments) => {
            this.segments = [ ...this.segments, ...segments.data ];
            this.segmentsMetaData = segments.meta.pagination;
        });
    }

    resetSegmentsPagination() {
        this.resetSegmentsSelectPagination = true;
        this.currentSegmentsPage = 1;
    }

    setDefaultFields() {
        this.formatAndAddField(this._translator('GLOBAL:TAG'), null, null, null, 'tags');
        this.formatAndAddField(this._translator('GLOBAL:FILTER'), null, null, null, 'filters');
    };

    setCustomizedFields() {
        this.customizations.forEach((group) => {
            group.fields.forEach((field) => {
                this.formatAndAddField(
                    field.name,
                    group.name,
                    group.id,
                    field.type,
                    field.id
                );
            });
        });
    };

    formatAndAddField(name, groupName, groupID, type, id) {
        this.formattedFields.push({
            name: name,
            groupName: groupName,
            groupID: groupID,
            type: type ? this._translator('CUSTOM_FIELDS:TYPE:' + type.toUpperCase()) : type,
            typeId: type,
            id: id,
            chosen: false
        });
    };

    getCasesFromHtml() {
        this.cases = $(this._element).find('rm-block-switch-default, rm-block-switch-case');
    }

    addCase() {
        let newCase = {};
        let content = '';
        $.extend(newCase, this.currentCase);
        angular.forEach(this.cases, (switchCase) => {
            if (this.isDefault($(switchCase))) {
                content = $(switchCase).html();
            }
        });
        if (!content) {
            content = newCase.element.html();
        }

        newCase.element = $('<rm-block-switch-case data-value="">' + content + '</rm-block-switch-case>').clone();
        newCase.isDefault = false;

        this.currentCase.element.hide();
        this.currentCase.element.after(newCase.element.clone());
        this.currentCase = newCase;
        this.currentCase.index++;
        this.getCasesFromHtml();
        this.slideCase('right', true);
    }

    transformCaseToDefault() {
        this.currentCase.isDefault = true;
        $(this.cases[this.currentCase.index]).replaceWith(
            $("<rm-block-switch-default>")
                .css({ 'width': '660px', 'margin-left': 0, 'display': 'block' })
                .html(this.currentCase.element.html())
        );
        this.getCasesFromHtml();
        this.currentCase.element = $(this.cases[this.currentCase.index]);

        this.getCasesFromHtml();
        if (this.cases.length > 1) {
            this.moveCaseToFirstPosition();
        }

    }

    moveCaseToFirstPosition() {
        this.getCasesFromHtml();
        $(this.cases[0]).before($(this.currentCase.element));
        this.getCasesFromHtml();

        this.setCurrentCase();
    }

    removeCase() {
        this.cases.splice(this.currentCase.index, 1);
        if (this.currentCase.index > 0) {
            this.currentCase.index--;
        }

        this.currentCase.element.remove();
        this.currentCase.field_value = null;
        this.slideCase('left');
    }

    slide(direction) {
        if (direction === 'left') {
            if (this.currentCase.index > 0) {
                this.currentCase.index--;
                this.slideCase(direction);
            }
        } else if (direction === 'right') {
            if (this.currentCase.index < this.cases.length - 1) {
                this.currentCase.index++;
                this.slideCase(direction);
            }
        }
    }

    slideCase(direction, add = false) {
        this.currentCase.element.hide();
        this.currentCase.element = $(this.cases[this.currentCase.index]);
        this.currentCase.field_value = this.isCustomizationSwitch() ? this.currentCase.element.attr('data-value') : parseInt(this.currentCase.element.attr('data-value'));
        this.currentCase.isDefault = this.isDefault(this.currentCase.element);

        let parentWidth = this.currentCase.element.parent().width();
        this.currentCase.element.width(parentWidth);

        if (direction === 'left') {
            this.currentCase.element.css("margin-left", "-120%");
        } else if (direction === 'right') {
            this.currentCase.element.css("margin-left", "120%");
        }
        this.currentCase.element.css("display", "block");
        this._timeout(() => {
            if (add) {
                this.currentCase.element.animate({ "margin-left": '0%' }, 300, () => {
                    this._scope.$emit('element:added', this.currentCase.element);
                });
            } else {
                this.currentCase.element.animate({ "margin-left": '0%' }, 300);
            }
        });

        this.updateSelectedEntitiesMap();
    }

    updateSelectedEntitiesMap() {
        if (!this.currentCase.field_value) {
            return;
        }

        switch (this.currentCase.field) {
            case 'filters':
                this.updateSegmentsMap();
                break;
            case 'tags':
                this.updateTagsMap();
                break;
        }
    }

    updateTagsMap() {
        if (!this.selectedTagsMap.has(this.currentCase.field_value)) {
            const selectedTagFromLoadedTags = this.tags && this.tags.find((tag) => tag.id === this.currentCase.field_value);

            if (selectedTagFromLoadedTags) {
                this.selectedTagsMap.set(this.currentCase.field_value, selectedTagFromLoadedTags);
            } else {
                this.tagRepo.find(this.currentCase.field_value).then((tag) => {
                    this.selectedTagsMap.set(this.currentCase.field_value, tag.data);
                });
            }
        }
    }

    updateSegmentsMap() {
        if (!this.selectedSegmentsMap.has(this.currentCase.field_value)) {
            const selectedSegmentFromLoadedSegments = this.segments && this.segments.find((segment) => segment.id === this.currentCase.field_value);

            if (selectedSegmentFromLoadedSegments) {
                this.selectedSegmentsMap.set(this.currentCase.field_value, selectedSegmentFromLoadedSegments);
            } else {
                this.segmentRepo.find(this.currentCase.field_value).then((segment) => {
                    this.selectedSegmentsMap.set(this.currentCase.field_value, segment.data);
                });
            }
        }
    }

    getHeaderCaseInfo() {
        let getShowNameFromId = (items, id) => {
            let showName = '';

            angular.forEach(items, (element) => {
                if (element.id == id) {
                    showName = !this.isCustomizationSwitch() ? element.name : element.groupName + '.' + element.name;
                }
            });

            return showName || '';
        };

        if (this.currentCase.field_value) {
            if (!this.isCustomizationSwitch()) {
                if (this.currentCase.field === 'tags') {
                    const selectedTag = this.selectedTagsMap.get(this.currentCase.field_value);
                    this.headerCaseInfo = this._translator('MAILEDITOR:SWITCH:CASE_TAG_IS') + (selectedTag ? selectedTag.name : '');
                } else if (this.currentCase.field === 'filters') {
                    const selectedSegment = this.selectedSegmentsMap.get(this.currentCase.field_value);
                    this.headerCaseInfo = this._translator('MAILEDITOR:SWITCH:CASE_SEGMENT_IS') + (selectedSegment ? selectedSegment.name : '');
                }
            } else {
                this.headerCaseInfo = getShowNameFromId(this.formattedFields, parseInt(this.currentCase.field)) + this._translator('MAILEDITOR:SWITCH:CASE_IS') + (this.currentCase.field_value ? this.currentCase.field_value : '');
            }
        }

        return this.headerCaseInfo;
    }


    canRemoveCase() {
        return this.cases && this.cases.length > 1;
    }

    canAddDefaultCase() {
        return $(this._element).find('rm-block-switch-default').length === 0;
    }
}
